import {useDispatch} from 'react-redux'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {authTokenRetrieved} from '../../../../store/state/auth/action-creators'
import {oauthClientIdsSelector} from '../../../../store/state/config/selectors'
import {type CredentialResponse, GoogleLogin} from '@react-oauth/google'
import {StringUtils} from '../../../../utils/Utils'

import type {JSX} from 'react'

export function AdminSignInButton(): JSX.Element | null {
    const dispatch = useDispatch()

    function responseGoogleSuccess(tokenResponse: CredentialResponse): void {
        const authToken = tokenResponse.credential
        if (!StringUtils.validString(authToken)) {
            throw new Error('Credentals response was empty')
        }

        dispatch(authTokenRetrieved(authToken))
    }

    function responseGoogleFailure(response: string): void {
        console.error(response)
        throw new Error(`Failure during login: error: ${response} (Details: ${response})`)
    }
    const oauthClientIds = useTypedSelector(oauthClientIdsSelector)
    const isLoginEnabled = oauthClientIds != undefined
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!isLoginEnabled || !oauthClientIds || !oauthClientIds.google) {
        return null
    }

    return (
        <GoogleLogin
            onSuccess={responseGoogleSuccess}
            onError={() => {
                responseGoogleFailure('Login Failed')
            }}
        />
    )
}
